import * as React from 'react';

import { Seat } from '../../classes/seat';
import SeatInfoHeader from './seat-info-header';


export interface ISeatInfoHeaderContainerProps {
    seat: Seat
    useZoneDescription: boolean;
    isGAZone?: boolean;
}

class SeatInfoHeaderContainer extends React.PureComponent<ISeatInfoHeaderContainerProps, any>{
    static defaultProps = {
        isGAZone: false
    }

    getSeatDescription(props: ISeatInfoHeaderContainerProps): string {
        const { seat, isGAZone } = props;
        const description = `${this.props.useZoneDescription && seat.zoneDescription !== null ? seat.zoneDescription : seat.tessituraSeat.sectionDescription}`;
        return isGAZone ? description : description;
    }

    getSeatRowNumber(props: ISeatInfoHeaderContainerProps): string {
        const { seat, isGAZone } = props;
        return isGAZone ? ` ${seat.tessituraSeat.rowText}-${seat.tessituraSeat.numberText}` : ` ${seat.tessituraSeat.rowText}-${seat.tessituraSeat.numberText}`;
    }


    render() {
        return <SeatInfoHeader
            seatDescription={this.getSeatDescription(this.props)}
            seatRowNumber={this.props.isGAZone ? null : this.getSeatRowNumber(this.props)}
            {...this.props.seat.seatStyleCulture}
            {...this.props.seat.seatStyle}
        />

    }
}

export default SeatInfoHeaderContainer;